// Module
var code = `<canvas></canvas><div class="loading-indicator" ng-if="isRendering"><span class="ficon-spinner ficon-spin"></span></div>`;
// Exports
export default code;